/**
 *  @class
 *  @function CollectionSliders
 */

if (!customElements.get('collection-sliders')) {
  class CollectionSliders extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      setTimeout(() => {
        const buttons = Array.from(this.querySelectorAll('.collection-sliders__tab-buttons button'));
        const sliders = Array.from(this.querySelectorAll('slide-show'));
        buttons.forEach((button, i) => {
          button.addEventListener('click', (event) => {
            this.toggleButtons(buttons, i);
            this.toggleSliders(sliders, i);
            event.preventDefault();
          });
        });
        window.addEventListener('resize', () => {
          const slider = this.querySelector('slide-show.active');
          if (!slider) return; // Ensure the existence of the slider
          let flkty = Flickity.data(slider);
          flkty.resize();
        });
        if (Shopify.designMode) {
          this.addEventListener('shopify:block:select', (event) => {
            const index = buttons.indexOf(event.target);
            if (index !== -1) {
              buttons[index].dispatchEvent(new Event('click'));
            }
          });
        }
      }, 10);
    }

    toggleButtons(buttons, index) {
      buttons.forEach((button) => button.classList.remove('active'));
      buttons[index].classList.add('active');
    }

    toggleSliders(sliders, index) {
      if (sliders.length) {
        sliders.forEach((slider) => slider.classList.remove('active'));
        sliders[index].classList.add('active');
        const flkty = Flickity.data(sliders[index]);
        flkty.resize();
      }
    }
  }
  customElements.define('collection-sliders', CollectionSliders);
}
